import React, { useState } from "react";
import FloatingLabelInput from "../../../common/components/FloatingLabelInput";
import { t } from "i18next";
import { updateRepresentative } from "../../../api/postCompanyData";
import Modal from "../../../common/components/MessageModal";

export default function GeneralInfo({ companyInfo, userInfo }) {
    const safeCompanyInfo = companyInfo || {};
    const safeUserInfo = userInfo || {};

    const [representative, setRepresentative] = useState({
        name: safeCompanyInfo.representative?.name || "",
        position: safeCompanyInfo.representative?.position || ""
    });

    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState({ show: false, message: "" });

    const handleInputChange = (field, value) => {
        setRepresentative(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await updateRepresentative(representative);
            setModal({ show: true, message: t('dataUpdateSuccess') });
        } catch (error) {
            console.error("Update failed:", error);
            setModal({ show: true, message: t('updateError') });
        } finally {
            setLoading(false);
        }
    };

    if (!companyInfo || !userInfo) {
        return <div className="text-gray-500 text-sm">{t('loading') || "Loading..."}</div>;
    }

    return (
        <div className="flex flex-col gap-6">
            {/* Company info — readonly */}
            <div>
                <h3 className="text-base font-semibold text-gray-800 mb-4">{t('general')}</h3>
                <div className="flex flex-col gap-4 max-w-md">
                    <FloatingLabelInput
                        label={t('bin')}
                        value={safeCompanyInfo.company_bin || ""}
                        onChange={() => {}}
                        type="text"
                        readOnly
                    />
                    <FloatingLabelInput
                        label={t('nameLabel')}
                        value={safeUserInfo.name || ""}
                        onChange={() => {}}
                        type="text"
                        readOnly
                    />
                    <FloatingLabelInput
                        label={t('phoneNumber')}
                        value={safeUserInfo.phone_number || ""}
                        onChange={() => {}}
                        type="text"
                        readOnly
                    />
                </div>
            </div>

            <div className="border-t border-gray-100" />

            {/* Representative — editable */}
            <div>
                <h3 className="text-base font-semibold text-gray-800 mb-4">{t('personalData')}</h3>
                <form className="flex flex-col gap-4 max-w-md" onSubmit={handleSubmit}>
                    <FloatingLabelInput
                        label={t('nameLabel')}
                        value={representative.name}
                        onChange={(e) => handleInputChange('name', e.target.value)}
                        type="text"
                    />
                    <FloatingLabelInput
                        label={t('position')}
                        value={representative.position}
                        onChange={(e) => handleInputChange('position', e.target.value)}
                        type="text"
                    />
                    <div>
                        <button
                            type="submit"
                            className="bg-[#147F26] text-white py-2.5 px-6 rounded-xl font-medium hover:bg-[#0f5f1a] disabled:opacity-60 transition"
                            disabled={loading}
                        >
                            {loading ? t('saving') : t('save')}
                        </button>
                    </div>
                </form>
            </div>

            {modal.show && (
                <Modal
                    message={modal.message}
                    onClose={() => setModal({ show: false, message: "" })}
                />
            )}
        </div>
    );
}
